var map = {
	"./activity_fetch.svg": 2631,
	"./activity_run.svg": 3899,
	"./activity_swim.svg": 2942,
	"./activity_tab_icon_unselected.svg": 3868,
	"./activity_walk.svg": 5329,
	"./add_avatar_placeholder_green.png": 1572,
	"./add_avatar_placeholder_orange.png": 4710,
	"./add_black.svg": 5482,
	"./add_food_placeholder_green.png": 4155,
	"./add_food_placeholder_orange.png": 3273,
	"./add_green.svg": 4561,
	"./add_orange.svg": 9808,
	"./add_profile.svg": 136,
	"./add_round_black.svg": 5055,
	"./add_round_green.svg": 5069,
	"./add_round_orange.svg": 4899,
	"./add_round_white.svg": 134,
	"./add_white.svg": 8430,
	"./arrow_down_black.svg": 8943,
	"./arrow_down_green.svg": 9500,
	"./arrow_down_orange.svg": 9384,
	"./arrow_left_black.svg": 3529,
	"./arrow_left_green.svg": 9153,
	"./arrow_left_orange.svg": 9907,
	"./arrow_right_black.svg": 4417,
	"./arrow_right_green.svg": 1108,
	"./arrow_right_orange.svg": 5382,
	"./arrow_up_black.svg": 1403,
	"./arrow_up_green.svg": 1959,
	"./arrow_up_orange.svg": 6093,
	"./avatar_placeholder.png": 8980,
	"./avatar_small_placeholder.png": 9229,
	"./back_arrow.svg": 5065,
	"./bones.png": 5793,
	"./calories.png": 1244,
	"./cancel_black.svg": 8916,
	"./cancel_green.svg": 8686,
	"./cancel_orange.svg": 669,
	"./cancel_white.svg": 5507,
	"./change_profile.svg": 1962,
	"./checkmark_black.svg": 1867,
	"./checkmark_green.svg": 5792,
	"./checkmark_orange.svg": 9957,
	"./checkmark_white.svg": 3113,
	"./close_round_black.svg": 3345,
	"./close_round_green.svg": 9709,
	"./close_round_orange.svg": 1879,
	"./close_round_white.svg": 511,
	"./copy_black.svg": 9639,
	"./copy_green.svg": 4559,
	"./copy_orange.svg": 5428,
	"./copy_white.svg": 96,
	"./dashboard_tab_icon_selected.png": 484,
	"./dashboard_tab_icon_unselected.png": 735,
	"./dashboard_tab_icon_unselected.svg": 329,
	"./delete_account.svg": 2483,
	"./delete_black.svg": 1601,
	"./delete_green.svg": 1575,
	"./delete_orange.svg": 5960,
	"./delete_white.svg": 5663,
	"./diary_tab_icon_unselected.svg": 990,
	"./dog_sit.png": 1358,
	"./dryFood.png": 6334,
	"./edit_black.svg": 9290,
	"./edit_green.svg": 9810,
	"./edit_orange.svg": 3369,
	"./edit_white.svg": 5655,
	"./fiber.png": 9246,
	"./fish.png": 2553,
	"./food_placeholder.png": 4532,
	"./fruits.png": 1412,
	"./general_error.png": 3963,
	"./giblets.png": 7049,
	"./health_tab_icon_unselected.svg": 3317,
	"./hide_password.svg": 3034,
	"./liver.png": 1008,
	"./logo.png": 5886,
	"./logo_green_stroke.png": 7779,
	"./logout_tab_icon_unselected.svg": 3282,
	"./meat.png": 7102,
	"./minus_round_button.svg": 2079,
	"./more_black.svg": 3864,
	"./more_green.svg": 4686,
	"./more_orange.svg": 883,
	"./more_tab_icon_unselected.svg": 7243,
	"./more_white.svg": 8996,
	"./no_activities_placeholder.png": 8106,
	"./no_chart_placeholder.png": 8891,
	"./no_data_placeholder.png": 6224,
	"./no_food_placeholder.png": 6879,
	"./no_meals_placeholder.png": 5627,
	"./no_percentage_placeholder.png": 461,
	"./no_results_placeholder.png": 9677,
	"./no_trainings_placeholder.png": 4688,
	"./no_weights_placeholder.png": 5309,
	"./other.png": 3861,
	"./paw_white.png": 3580,
	"./plus_round_button.svg": 520,
	"./plus_round_fill_button.svg": 5053,
	"./plus_round_fill_white_button.svg": 7630,
	"./recipe.png": 8132,
	"./save_black.svg": 6095,
	"./save_green.svg": 2845,
	"./save_orange.svg": 4657,
	"./save_white.svg": 3308,
	"./seeds.png": 6073,
	"./show_password.svg": 9597,
	"./spinner/activity_indicator1.png": 81,
	"./spinner/activity_indicator2.png": 6521,
	"./spinner/activity_indicator3.png": 1609,
	"./spinner/activity_indicator4.png": 7290,
	"./spinner/activity_indicator5.png": 7092,
	"./start_typing_placeholder.png": 5875,
	"./stat_placeholder.png": 1155,
	"./suplements.png": 2242,
	"./training_custom.svg": 9722,
	"./training_items.svg": 6869,
	"./training_obedience.svg": 875,
	"./training_potty.svg": 4902,
	"./training_social.svg": 4775,
	"./training_sounds.svg": 312,
	"./training_tab_icon_unselected.svg": 4479,
	"./treat.png": 1467,
	"./trophy.svg": 2286,
	"./veggie.png": 6136,
	"./wetFood.png": 3406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4560;